import React, { useCallback, useEffect, useState } from 'react'
import { JSX } from 'react/jsx-runtime'
import Select from 'live/components/forms/ui/select'
import { SelectWrapper } from '../styles/ChannelStyle'
import { getActiveOption, rigFloorMethodologyOptions } from '../common'
import { KPISDrillingRegistryContextType } from '../../types/kpis-drilling/kpis-drilling-registry-type'
import { SelectOptionsPreset } from '../../types'

export const RealtimeRigFloorSelectMethodoly = (props: KPISDrillingRegistryContextType): JSX.Element => {
    const { contextState, setContextState } = props
    const { hasPermissionToEdit, collapsed } = contextState?.realtime?.props || {}
    const { isProducingData } = contextState?.realtime?.rigfloor || {}

    const [selectedMethodology, setSelectedMethodology] = useState<SelectOptionsPreset>(
        getActiveOption(rigFloorMethodologyOptions)
    )

    const handleMethodologyChange = useCallback(
        (el: string, ind: SelectOptionsPreset): void => {
            setSelectedMethodology(ind)
            setContextState(prevState => ({
                ...prevState,
                realtime: {
                    ...prevState?.realtime,
                    // creating rigfloor if is not exist
                    rigfloor: {
                        ...prevState?.realtime?.rigfloor,
                        selectedMethodology: ind,
                        setSelectedMethodology
                    }
                }
            }))
        },
        [setContextState]
    )

    useEffect(() => {
        setContextState(prevState => ({
            ...prevState,
            realtime: {
                ...prevState?.realtime,
                // creating rigfloor if is not exist
                rigfloor: {
                    ...prevState?.realtime?.rigfloor,
                    setSelectedMethodology
                }
            }
        }))
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    if (collapsed) {
        return (
            <div style={{ fontSize: '13px', color: 'var(--gray-800)', height: '36px', display: 'flex', alignItems: 'center' }}>
                {selectedMethodology?.label ?? '--'}
            </div>
        )
    }

    return (
        <SelectWrapper>
            <Select
                style={{ minWidth: '200px', maxHeight: '50px' }}
                disabled={!hasPermissionToEdit || isProducingData}
                clearable={false}
                searchable={false}
                options={rigFloorMethodologyOptions}
                value={selectedMethodology?.value}
                onChange={handleMethodologyChange}
                placeholder={selectedMethodology?.label}
            />
        </SelectWrapper>
    )
}
